import type { ButtonType } from "../../../src/models/BaseDeviceProps";
import type { C1_ButtonUiTemplate } from "../data/C1_ProductDefinitions";

/** Maps the product type to one of the available front-view renderers. */
export function buttonUiTemplate(type?: ButtonType): C1_ButtonUiTemplate {
  if (type === "Touch") return "touch";
  if (type === "Panel") return "panel";
  return "simple";
}
